// import { wsPivotRequest } from '@/utils/ws'
import { request } from '@/utils/request'
import { chatState } from '@/store'

// eslint-disable-next-line @typescript-eslint/member-delimiter-style
export const uploadFile = ({
  file,
  url,
  inputFileList,
}: {
  file?: any
  url?: string
  inputFileList?: any
}) => {
  let sessionId = chatState.sessionId

  const formdata = new FormData()
  if (file) {
    formdata.append('upFile', file || null)
  }
  if (url) {
    formdata.append('url', url)
  }
  formdata.append('combine_file', 'true')

  return request({
    method: 'post',
    url: '/uploadFile/',
    data: formdata,
    timeout: 1000 * 60 * 3,
    headers: {
      'Content-Type': 'multipart/form-data',
      session: sessionId,
    },
    onUploadProgress: progressEvent => {
      // 如果inputFileList存在, 计算上传的百分比
      if (inputFileList) {
        const percentCompleted = Math.ceil(progressEvent.loaded * 100)
        // eslint-disable-next-line no-restricted-syntax
        for (const item of inputFileList) {
          if (item.uid === file.uid) {
            item.progress = percentCompleted
          }
        }
      }
    },
  })
}

export const evaluate = (payload: any) => {
  return request.post('/evaluate', payload)
}

export const getHistory = () => {
  return request.get('/history')
}

export const deleteHistory = (sessionId: string) => {
  return request.delete(`/history/${sessionId}`)
}

export const uploadHistory = (sessionId: string, payload: any) => {
  return request.post(`/history/${sessionId}`, payload)
}

export const deleteAllHistory = () => {
  return request.delete('/all_history')
}

export const getSession = (sessionId: string) => {
  return request.get(`/history/${sessionId}?combine_file=${true}`)
}

export const updatePlugins = (payload: any) => {
  return request.post('/updateplugins', payload)
}

export const getPrompt = () => {
  return request.get('/prompt/')
}

export const getTTSconfig = () => {
  return request.get('/get_tts_config')
}

export enum CONFIGNAME {
  RIGHT = 'right',
  STATUS = 'status',
  PROMPT = 'prompt',
  BANNER = 'banner',
}

export const getConfig = (name: CONFIGNAME) => {
  return request.get(`/config/${name}`)
}

export const setConfig = (name: CONFIGNAME, payload: any) => {
  return request.post(`/config/${name}`, payload)
}

export const stopGenarate = (payload: any) => {
  return request.post('/chat/stop', payload)
}

export const getppturl = (id: string) => {
  return request.get(`/plugin/getppturl?id=${id}`)
}

// 全新的问答
export const newChat = (payload: any) => {
  return request.post('/chat/newchat', payload)
}

// 获取 processon 预授权地址
export const getProcessonUrl = (url: string) => {
  return request.get(`/plugin/processonurl?url=${encodeURIComponent(url)}`)
}

export const getShareDetail = (share_id: string) => {
  return request.get(`/history/share_detail?share_id=${share_id}`)
}

export const getRecommend = (session_id: string) => {
  return request.get(`/query_recommend?session_id=${session_id}`, {
    timeout: 5000,
  })
}

export const pushEvent = (payload: any) => {
  return request.post('/push_event', payload)
}
